export default "/static/dashboard/build/app/img/v2/4015b209f4cd48a59a3478cd2b79f4ee.png";